import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TabsModule } from 'primeng/tabs';
import { SettingsService } from '../settings-page/settings-service/settings.service';
import { CadStorageTabComponent } from './cad-storage-tab/cad-storage-tab.component';
import { DrawingStorageTabComponent } from './drawing-storage-tab/drawing-storage-tab.component';

type StorageTab = 'cad' | 'drawing';

/** Storage: CAD files and drawing PDFs, each listed and fetched separately. */
@Component({
  selector: 'app-storage-page',
  imports: [TabsModule, CadStorageTabComponent, DrawingStorageTabComponent],
  templateUrl: './storage-page.component.html',
})
export class StoragePageComponent implements OnInit, OnDestroy {
  private settingsService = inject(SettingsService);
  private subscription = new Subscription();

  isDrawingsEnabled = false;
  activeTab: StorageTab = 'cad';

  ngOnInit(): void {
    this.subscription.add(
      this.settingsService
        .isPdfDrawingUploadEnabled$()
        .subscribe((isEnabled) => {
          this.isDrawingsEnabled = isEnabled;
        }),
    );
  }

  onTabChange(value: unknown): void {
    this.activeTab = value === 'drawing' ? 'drawing' : 'cad';
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
